
import { isSignedIn, userProfile } from '@/services/user'

export default {
  setup() {
    return { isSignedIn, userProfile }
  }
}
